import { SagaIterator } from 'redux-saga';
import { takeEvery, takeLatest } from 'redux-saga/effects';

import {
  EnterPublishedConnectionTableSubspace,
  PublishedConnectionTableCountsRequest,
  PublishedConnectionTableExtractsRefreshNow,
} from '~src/bootstrap/redux/actions/AppActionTypes';
import { handlePublishedConnectionTableRefreshNowExtract } from '~src/publishedConnectionTable/sagas/PublishedConnectionTableExtractsRefreshNowSaga';

import { handleEnterPublishedConnectionTableSubspace } from './EnterPublishedConnectionTableSpaceSaga';
import { handlePublishedConnectionTableCountsRequest } from './PublishedConnectionTableCountsRequestSaga';

export function* rootPublishedConnectionTableSaga(): SagaIterator {
  yield takeLatest(EnterPublishedConnectionTableSubspace, handleEnterPublishedConnectionTableSubspace);
  yield takeLatest(PublishedConnectionTableCountsRequest, handlePublishedConnectionTableCountsRequest);
  yield takeEvery(PublishedConnectionTableExtractsRefreshNow, handlePublishedConnectionTableRefreshNowExtract);
}
